module.exports = __webpack_public_path__ + "img/new-guide-03-2.16ff8e8a.png";